var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentDocument)?_c('DialogTermsAndConditions',{attrs:{"consent-document":_vm.currentDocument,"filterMeta":{ consentDocumentCuid: _vm.currentDocument.cuid },"closable":false,"standalone":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }